import { Injectable } from '@angular/core';
import { tap, mapTo } from 'rxjs/operators';
import { ApiService } from '../../shared/services/core/api.service';
import { of, Observable } from 'rxjs';
import { LoggingService } from '../../shared/services/core/logging.service';
import { LottoWalletStore } from './lotto-wallet.store';
import { LottoWalletQuery } from './lotto-wallet.query';
import { LottoWalletItem } from './models/lotto-wallet-item.model';

@Injectable({ providedIn: 'root' })
export class LottoWalletService {
  constructor(
    private lottoWalletStore: LottoWalletStore,
    private lottoWalletQuery: LottoWalletQuery,
    private api: ApiService,
    private logService: LoggingService
  ) {}

  /** Fetches the lotto wallet items and puts them in the store. */
  fetchLottoWalletItems(): Observable<null> {
    this.lottoWalletStore.setLoading(true);
    this.logService.info('making call for lotto wallet items');

    const request$: Observable<null> = this.api.get<LottoWalletItem>('lottos/wallet').pipe(
      tap(lottos => this.lottoWalletStore.set(lottos)),
      mapTo(null)
    );

    return this.lottoWalletQuery.getHasCache() ? of(null) : request$;
  }
}
